/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import {
    hasRequiredStorefrontFields,
    mergeStorefrontCtx
} from '../shared/storefront-context'

const topSearchContext = {
    /**
     * Get storefront events SDK reference.
     *
     * @returns {Object|null}
     */
    mse() {
        if (typeof window === 'undefined') {
            return null
        }

        return window.magentoStorefrontEvents || null
    },

    /**
     * Ensure storefront instance context exists before publishing events.
     */
    ensureStorefrontInstanceCtx() {
        const mse = this.mse()
        if (!mse || !mse.context?.getStorefrontInstance || !mse.context?.setStorefrontInstance) {
            return
        }

        const currentStorefrontCtx = mse.context.getStorefrontInstance() || {}
        if (hasRequiredStorefrontFields(currentStorefrontCtx)) {
            return
        }

        const fallbackStorefrontCtx = window?.liveSearchConfig?.storefrontInstance || {}
        if (!hasRequiredStorefrontFields(fallbackStorefrontCtx)) {
            return
        }

        mse.context.setStorefrontInstance(
            mergeStorefrontCtx(currentStorefrontCtx, fallbackStorefrontCtx)
        )
    },

    /**
     * handle context input
     */
    handleContextInput() {
        const mse = this.mse()
        if (!mse) {
            return
        }

        this.ensureStorefrontInstanceCtx()

        const searchCtx = {
            units: [{
                searchUnitId: 'search-bar',
                queryTypes: ['products', 'suggestions', 'categories'],
                phrase: this.queryPhrase,
                currentPage: 1,
                pageSize: this.topSearchPageSize,
                filter: this.filterOptions,
                sort: this.sortOptions,
                searchRequestId: this.searchRequestId
            }]
        }

        mse.context.setSearchInput(searchCtx)
        mse.publish.searchRequestSent('search-bar')
    },
    /**
     * handle context results
     *
     * @param result
     * @param before
     * @param after
     */
    handleContextResults(result, before, after) {
        const mse = this.mse()
        if (!mse) {
            return
        }

        this.ensureStorefrontInstanceCtx()

        const formattedProductItems = this.formatContextProductItems(result.productSearch.items)
        const formattedSuggestions = this.formatContextSuggestions(result.productSearch.suggestions)
        const formattedFacets = this.formatContextFacets(result.productSearch.facets)

        const searchCtxUpdated = {
            units: [{
                searchUnitId: 'search-bar',
                searchRequestId: this.searchRequestId,
                executionTime: after - before,
                products: formattedProductItems,
                categories: [],
                suggestions: formattedSuggestions,
                page: result.productSearch.page_info.current_page,
                perPage: result.productSearch.page_info.page_size,
                facets: formattedFacets
            }]
        }

        mse.context.setSearchResults(searchCtxUpdated)
        mse.publish.searchResponseReceived('search-bar')
        mse.publish.searchResultsView('search-bar')
    }
}

export default topSearchContext
